module.exports = __webpack_public_path__ + "static/fonts/Fact-NarrowLight.ba0269b.woff";